export const getAvailableAnnotationViewTabs = ({
	leadCount,
	leadAnnotatorEnabled,
	medianBeatPlotEnabled,
	rrIntervalPlotEnabled,
	instructionsAvailable,
}) => [
	0,
	...(leadCount >= 7 ? [1] : []),
	...(leadAnnotatorEnabled ? [2] : []),
	...(medianBeatPlotEnabled ? [3] : []),
	...(rrIntervalPlotEnabled ? [4] : []),
	...(instructionsAvailable ? [5] : []),
]

export const getNextAnnotationViewTab = (currentTab, options) => {
	const availableTabs = getAvailableAnnotationViewTabs(options)
	const currentIndex = availableTabs.indexOf(currentTab)
	return currentIndex === -1
		? availableTabs[0]
		: availableTabs[(currentIndex + 1) % availableTabs.length]
}

